import {
  useAgentDashboardCountersQuery,
  useMissedAppsTagId,
} from '../../../shared';


export default function useAgentDashboardCounters(agentId?: string) {
  const missingAppsTagId = useMissedAppsTagId();
  const {data, refetch} = useAgentDashboardCountersQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      agentId, missingAppsTagId
    },
    skip: !agentId || !missingAppsTagId,
  })

  return {
    counters: data ? {
      contacted: parseFloat(data.contacted.totalElements),
      missingApps: parseFloat(data.missingApps.totalElements),
      todayFollowUps: parseFloat(data.followUps.totalElements),
      futureFollowUps: parseFloat(data.followUpsFuture.totalElements),
      todaySQL: parseFloat(data.salesQualified.totalElements),
      futureSQL: parseFloat(data.salesQualifiedFuture.totalElements),
    } : undefined,
    refetch};
}
